/**
 * Returns the account logo from a HierarchyItem (Album or AlbumFolder).
 *
 * @param {Object} hierarchyItem The HierarchyItem containing the Album or AlbumFolder.
 * @returns {string}
 */
export const getAccountLogoFromHierarchyItem = hierarchyItem => {
  if (!hierarchyItem) {
    return '';
  }

  return (
    hierarchyItem.album_folder?.account.logo_image?.url ??
    hierarchyItem.album?.creator.logo_image?.url ??
    ''
  );
};
